import { LoaderFunction, useFetcher } from "react-router-dom";
import {
  activatePromotion,
  returnPromotion,
} from "../../../../common/api/bridge/methods.ts";

export const promotionActivateAction: LoaderFunction = async ({ params }) => {
  if (params.vbid) {
    try {
      await activatePromotion(params.vbid);
      return {
        ok: true,
      };
    } catch {
      // Fall through to default ok: false at the end
    }
  }
  return { ok: false };
};

export const promotionReturnAction: LoaderFunction = async ({ params }) => {
  if (params.vbid) {
    try {
      await returnPromotion(params.vbid);
      return {
        ok: true,
      };
    } catch {
      // Fall through to default ok: false at the end
    }
  }
  return { ok: false };
};

export function usePromotionFetcher() {
  return useFetcher<{ ok: boolean }>();
}
